/* eslint-disable no-shadow */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { forwardRef } from "react";
import CurrencyInput from "react-currency-input-field";
import { CurrencyInputProps } from "react-currency-input-field/dist/components/CurrencyInputProps.d";
import { Widget, WidgetProps } from "@rjsf/core";

import { FormMessage, Input } from "@xometry/xometry_loft";

import { LabelWithOptionalFlag } from "./LabelWithOptionalFlag";
import { Section, ShortText } from "./Shared.style";

type CloneInputProps = CurrencyInputProps & {
  invalid: boolean;
};

const CloneInput = forwardRef((props: CloneInputProps, ref) => {
  const {
    type,
    inputMode,
    id,
    name,
    className,
    onChange,
    onBlur,
    onFocus,
    onKeyDown,
    onKeyUp,
    placeholder,
    disabled,
    invalid,
    value,
  } = props;
  return (
    <Input
      {...{
        type,
        inputMode,
        id,
        name,
        className,
        onChange,
        onBlur,
        onFocus,
        onKeyDown,
        onKeyUp,
        placeholder,
        disabled,
        invalid,
        value,
      }}
    />
  );
});

CloneInput.displayName = "CloneInput";

export const LoftCurrencyField: Widget = ({
  disabled,
  onBlur,
  onChange,
  options,
  rawErrors,
  required,
  schema,
  value,
  uiSchema,
}: WidgetProps) => {
  const isInvalid = !!(rawErrors?.length > 0 && options?.touched);

  // https://github.com/facebook/react/blob/9198a5cec0936a21a5ba194a22fcbac03eba5d1d/packages/react-dom/src/client/ReactDOMInput.js#L101
  // eslint-disable-next-line dot-notation
  return (
    <div css={[Section, options?.short && ShortText]}>
      <LabelWithOptionalFlag
        required={required}
        tooltip={(options?.tooltip || "") as string}
      >
        {schema.title}
      </LabelWithOptionalFlag>

      <CurrencyInput
        decimalSeparator="."
        groupSeparator=","
        prefix="$ "
        name={options?.name as string}
        disabled={disabled}
        defaultValue={value}
        onValueChange={newValue => {
          onChange(newValue || undefined);
        }}
        onBlur={e =>
          onBlur(e.currentTarget.name, e.currentTarget.value || null)
        }
        customInput={CloneInput}
        {...{ invalid: isInvalid }}
      />
      {uiSchema?.description && (
        <FormMessage>{uiSchema.description}</FormMessage>
      )}
      {isInvalid && (
        <FormMessage invalid>{rawErrors ? rawErrors[0] : ""}</FormMessage>
      )}
    </div>
  );
};
